import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";

function TrackingPanel({ children }: { children: ReactNode }) {
    const { t } = useTranslation();

    return <Panel title={<PanelTitle title={t("tracking")}></PanelTitle>}>{children}</Panel>;
}

export default TrackingPanel;
